import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-792725e4")
const _hoisted_1 = { class: "hero-container" }
const _hoisted_2 = { class: "hero-content" }
const _hoisted_3 = { class: "hero-text max-w-md py-8 px-4 lg:py-4 lg:px-8 xl:pt-0 2xl:px-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "eyebrow font-medium" }, "veBAL", -1)
const _hoisted_5 = { class: "title mb-5 text-white" }
const _hoisted_6 = { class: "mt-6 flex" }
const _hoisted_7 = { class: "coins" }
const _hoisted_8 = { class: "coin group" }
const _hoisted_9 = { class: "coin-wrapper w-full" }
const _hoisted_10 = { class: "caption font-semibold" }
const _hoisted_11 = { class: "mr-1 inline text-sm tracking-tighter lg:text-base lg:tracking-normal" }
const _hoisted_12 = { class: "coin group" }
const _hoisted_13 = { class: "coin-wrapper" }
const _hoisted_14 = { class: "caption font-semibold" }
const _hoisted_15 = { class: "mr-1 inline text-sm tracking-tighter lg:text-base lg:tracking-normal" }
const _hoisted_16 = { class: "coin group" }
const _hoisted_17 = { class: "coin-wrapper" }
const _hoisted_18 = { class: "caption font-semibold" }
const _hoisted_19 = { class: "mr-1 inline text-sm tracking-tighter lg:text-base lg:tracking-normal" }
_popScopeId()

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

/**
 * COMPOSABLES
 */

export default _defineComponent({
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

/**
 * COMPUTED
 */
const benefits = computed(() => [
  t('veBAL.hero.benefits.boost'),
  t('veBAL.hero.benefits.vote'),
  t('veBAL.hero.benefits.earn'),
]);

/**
 * METHODS
 */
function navigateToGetVeBAL() {
  router.push({
    name: 'get-vebal',
    query: {
      returnRoute: 'vebal',
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalImage = _resolveComponent("BalImage")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('veBAL.hero.title')), 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(benefits), (benefit, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "mb-2 flex items-center text-white"
            }, " – " + _toDisplayString(benefit), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_BalBtn, {
            class: "hero-btn btn-gold mr-3",
            onClick: navigateToGetVeBAL
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('veBAL.hero.buttons.getVeBAL')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_BalBtn, {
            tag: "a",
            href: "https://docs.balancer.fi/ecosystem/vebal-and-gauges",
            target: "_blank",
            rel: "noreferrer",
            color: "white",
            class: "hero-btn",
            outline: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('veBAL.hero.buttons.learnMore')) + " ", 1),
              _createVNode(_component_BalIcon, {
                name: "arrow-up-right",
                size: "sm",
                class: "ml-px transition-colors group-hover:text-pink-500"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_BalImage, {
              class: "graphic",
              width: "330",
              height: "377",
              src: require('@/assets/images/coins/coins-1.png'),
              alt: "BAL and WETH tokens"
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('veBAL.hero.tokens.balWETH')), 1),
            _createVNode(_component_BalTooltip, {
              iconSize: "xs",
              textAlign: "left",
              class: "mt-1 font-medium"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('veBAL.hero.tokenInfo.balWETH')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_BalImage, {
              class: "graphic",
              width: "330",
              height: "377",
              src: require('@/assets/images/coins/coins-2.png'),
              alt: "B-80BAL-20WETH LP token"
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('veBAL.hero.tokens.lpToken')), 1),
            _createVNode(_component_BalTooltip, {
              iconSize: "xs",
              textAlign: "left",
              class: "mt-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('veBAL.hero.tokenInfo.lpToken')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_BalImage, {
              class: "graphic",
              width: "330",
              height: "377",
              src: require('@/assets/images/coins/coins-3.png'),
              alt: "veBAL token"
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('veBAL.hero.tokens.veBAL')), 1),
            _createVNode(_component_BalTooltip, {
              iconSize: "xs",
              textAlign: "left",
              class: "mt-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('veBAL.hero.tokenInfo.veBAL')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})